const THREE = (window.THREE = require('three'));

class SpaceBackground extends THREE.Mesh {
  constructor(map) {
    const material = new THREE.MeshBasicMaterial({
      map,
      side: THREE.FrontSide,
      depthTest: false,
      depthWrite: false,
      lights: false,
      transparent: false,
    });
    const geometry = new THREE.PlaneBufferGeometry(2048, 1024, 1, 1);
    super(geometry, material);
  }
}

export default SpaceBackground;



// WEBPACK FOOTER //
// ./src/modules/parallax/webgl/SpaceBackground.js